var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section section-shaped section-lg my-0"},[_c('div',{staticClass:"container pt-lg-md"},[_c('div',{staticClass:"row hero--header__large"},[_vm._v("\n            "+_vm._s(_vm.$t("jobs"))+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }